// extracted by mini-css-extract-plugin
module.exports = {"entryBox":"EntryBox_entryBox__12vz4"};